<template>
  <div class="top-names-page">
    <div class="page-title">
      <div>
        <h1 class="with-subhead">
          Common names
        </h1>
        <p class="subhead">
          The most common surnames and given names in your family tree.
        </p>
      </div>
    </div>
    <ScopeLoadProgress v-if="scopeLoading"/>
    <template v-else>
    <div class="btn-group part-select" role="group" aria-label="Name part button group">
      <template v-for="part in nameParts" :key="part.id">
        <input type="radio" class="btn-check" name="part" :id="part.id" autocomplete="off" :value="part.id" v-model="selectedPartIdRef"/>
        <label class="btn btn-outline-primary btn-sm" :for="part.id">
          {{ part.text }}
        </label>
      </template>
    </div>
    <NameStreamgraph v-if="timeDataRef.length" :key="selectedPartIdRef" :data="timeDataRef" :name-part="namePartRef"/>
    </template>
  </div>
</template>

<style scoped lang="scss">
.top-names-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding-top: 1rem;

  .page-title {
    text-align: center;
  }
  
  p.subhead {
    margin: 0;
  }

  .part-select label {
    font-size: 0.875rem;
  }

  .streamgraph-wrapper {
    width: 100%;
  }
}
</style>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useNameCounts } from './NameCounts'
import ScopeLoadProgress from '@/explore/ScopeLoadProgress.vue'
import NameStreamgraph from './NameStreamgraph.vue'
import { PersonNamePart } from '@/rd/ResearchDataModel'
import { useExploreStore } from '@/explore/ExploreStore'
import { useViewScopeStore } from '@/explore/ViewScopeStore'
import { LoadMode } from '@/util/AsyncData'

const exploreStore = useExploreStore()
const viewScopeStore = useViewScopeStore()
const scopeLoading = computed(() => !viewScopeStore.getAsyncScopeInfo(exploreStore.startPersonId, LoadMode.EnsureLoaded)?.isLoaded)

const nameParts = [
  { id: 's', text: 'Surnames' },
  { id: 'g:male', text: 'Male names' },
  { id: 'g:female', text: 'Female names' },
]

const selectedPartIdRef = ref(nameParts[0].id)

const nameCounts = useNameCounts()

const timeDataRef = computed(() => nameCounts.nameTimeData.get(selectedPartIdRef.value) ?? [])
const namePartRef = computed(() => selectedPartIdRef.value === 's' ? PersonNamePart.Surname : PersonNamePart.Given)
</script>
